import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { color, gutter } from '../../styles/mixins';
import { caps12 } from '../../styles/typography';

const Host = styled.nav`
  position: sticky;
  top: 0;
  display: flex;
  flex-flow: column;

  z-index: 9;
  background-color: ${color('white')};

  padding: ${gutter(2)} ${gutter(3)};

  @media ${device.tablet} {
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const ActionText = styled.div`
  ${caps12};
  margin-bottom: ${gutter(2)};
  text-align: center;

  @media ${device.tablet} {
    margin-bottom: 0;
    text-align: left;
  }
`;
const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  > * {
    margin-left: ${gutter(2)};

    padding: 10px 10px;

    &:first-child {
      margin-left: 0;
    }
    @media ${device.tablet} {
      display: inline-flex;
      margin-left: ${gutter(4)};
      padding: 10px 32px;
    }
  }
`;

interface HeroActionProps {
  actionText?: string;
  actions?: React.ReactNode;
}

export const HeroAction = ({ actionText, actions }: HeroActionProps) => {
  return (
    <Host>
      <ActionText>{actionText}</ActionText>
      <Buttons>{actions}</Buttons>
    </Host>
  );
};
